<template>
    <div>
        <div style="margin: 0rem 0 0 0rem; border: 1px #DDDDDD solid;">
            <el-card class="box-card">
                <div slot="header">
                    <el-row style="margin-bottom: 20px">
                        <el-col :span="24">
                            <div style="line-height: 3rem; font-size: 1.5rem;">合同项目运行分析表</div>
                        </el-col>
                    </el-row>
                    <el-row style="margin-bottom: 20px">
                        <el-col :span="24" style="text-align: left;">
                            <el-date-picker
                                v-model="month"
                                :picker-options="pickerOptions"
                                type="month"
                                value-format="yyyy-MM"
                                placeholder="请选择日期">
                            </el-date-picker>
                            <el-button type="primary" @click="searchData()" icon="el-icon-search" style="margin-left: 10px;">查询</el-button>
                            <el-button type="primary" icon="element-icons el-icondaoru" @click="importExcel">导入</el-button>
                            <el-button type="primary" icon="element-icons el-icondaochu1" @click="exportExcel">导出</el-button>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="24" style="text-align: left;">
                            <span>查询到{{dataMonth}}数据，共{{total}}条</span>
                        </el-col>
                    </el-row>
                </div>

                <el-container>
					<el-main width ="100%">
                        <el-table style="text-align: center; width: 100%;"
                            border
                            height="600"
                            v-loading="loading" 
                            :data="lrfxbList" 
                            :row-class-name="tableRowClassName"
                            :span-method="objectSpanMethod"
                            :header-cell-style="headerStyle"
                            :cell-style="cellStyle">

                            <el-table-column label="大队名称" prop="ddmc"></el-table-column>
                            <!-- <el-table-column label="项目序号" prop="index">
                                <template slot-scope="scope">
                                    {{scope.$index+1}}
                                </template>
                            </el-table-column> -->
                            <el-table-column label="项目序号" prop="xmxh"></el-table-column>
                            <el-table-column label="合同名称" prop="htmc"></el-table-column>
                            <el-table-column label="合同情况">
                                <el-table-column label="合同总费用">
                                    <el-table-column label="1" prop="htzfy"></el-table-column>
                                </el-table-column>
                                <el-table-column label="单价">
                                    <el-table-column label="2" prop="dj"></el-table-column>
                                </el-table-column>
                                <el-table-column label="合同人数">
                                    <el-table-column label="3" prop="htrs"></el-table-column>
                                </el-table-column>
                                <el-table-column label="上岗人数">
                                    <el-table-column label="4" prop="sgrs"></el-table-column>
                                </el-table-column>
                                <el-table-column label="上岗人均">
                                    <el-table-column label="5" prop="sgrj"></el-table-column>
                                </el-table-column>
                            </el-table-column>
                            <el-table-column label="工资支出" header-align="center">
                                <el-table-column label="餐费">
                                    <el-table-column label="6" prop="cf"></el-table-column>
                                </el-table-column>
                                <el-table-column label="实发工资">
                                    <el-table-column label="7" prop="sfgz"></el-table-column>
                                </el-table-column>
                                <el-table-column label="小计">
                                    <el-table-column label="8" prop="gzzcxj"></el-table-column>
                                </el-table-column>
                                <el-table-column label="人均支出">
                                    <el-table-column label="9" prop="rjzc"></el-table-column>
                                </el-table-column>
                            </el-table-column>
                            <el-table-column label="缴金支出" header-align="center">
                                <el-table-column label="缴金人数">
                                    <el-table-column label="10" prop="jjrs"></el-table-column>
                                </el-table-column>
                                <el-table-column label="社保金个人685+单位1761">
                                    <el-table-column label="11" prop="sbj"></el-table-column>
                                </el-table-column>
                                <el-table-column label="2446">
                                    <el-table-column width="60"></el-table-column>
                                </el-table-column>
                                <el-table-column label="公积金个人181+单位181">
                                    <el-table-column label="12" prop="gjj"></el-table-column>
                                </el-table-column>
                                <el-table-column label="362">
                                    <el-table-column width="50"></el-table-column>
                                </el-table-column>
                                <el-table-column label="残保金(单位)">
                                    <el-table-column label="13" prop="cbj"></el-table-column>
                                </el-table-column>
                                <el-table-column label="98">
                                    <el-table-column width="50"></el-table-column>
                                </el-table-column>
                                <el-table-column label="小计">
                                    <el-table-column label="14" prop="jjzcxj"></el-table-column>
                                </el-table-column>
                            </el-table-column>
                            <el-table-column label="服装、装备支出" header-align="center">
                                <el-table-column label="服装">
                                    <el-table-column label="15" prop="fz"></el-table-column>
                                </el-table-column>
                                <el-table-column label="装备">
                                    <el-table-column label="16" prop="zb"></el-table-column>
                                </el-table-column>
                                <el-table-column label="小计">
                                    <el-table-column label="17" prop="fzzbzcxj"></el-table-column>
                                </el-table-column>
                            </el-table-column>
                            <el-table-column label="缴纳增值税6%">
                                <el-table-column>
                                    <el-table-column label="18" prop="jnzzs"></el-table-column>
                                </el-table-column>
                            </el-table-column>
                            <el-table-column label="个调税、工会费">
                                <el-table-column>
                                    <el-table-column label="19" prop="gtsghf"></el-table-column>
                                </el-table-column>
                            </el-table-column>
                            <el-table-column label="总成本支出">
                                <el-table-column>
                                    <el-table-column label="20" prop="zcbzc"></el-table-column>
                                </el-table-column>
                            </el-table-column>
                            <el-table-column label="总成本人均支出">
                                <el-table-column>
                                    <el-table-column label="21" prop="zcbrjzc"></el-table-column>
                                </el-table-column>
                            </el-table-column>
                            <el-table-column label="盈利情况" header-align="center">
                                <el-table-column label="盈利数">
                                    <el-table-column label="22" prop="yls"></el-table-column>
                                </el-table-column>
                                <el-table-column label="盈利率%">
                                    <el-table-column label="23" prop="yll"></el-table-column>
                                </el-table-column>
                            </el-table-column>
                            <el-table-column label="额外奖金费" header-align="center">
                                <el-table-column label="总奖金数">
                                    <el-table-column label="24" prop="zjjs"></el-table-column>
                                </el-table-column>
                                <el-table-column label="当月使用数">
                                    <el-table-column label="25" prop="dysys"></el-table-column>
                                </el-table-column>
                                <el-table-column label="结余数">
                                    <el-table-column label="26" prop="jys"></el-table-column>
                                </el-table-column>
                            </el-table-column>
                            <el-table-column label="合同外伙食费">
                                <el-table-column>
                                    <el-table-column label="27" prop="htwhsf"></el-table-column>
                                </el-table-column>
                            </el-table-column>
                            <el-table-column label="备注">
                                <el-table-column>
                                    <el-table-column label="28" prop="bz"></el-table-column>
                                </el-table-column>
                            </el-table-column>
                        </el-table>
                        <el-row style="margin-bottom: 20px">
                            <el-col :span="24" style="text-align: right; padding: 20px 30px;">
                                <span>制表人：{{zbr}}</span>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="24" style="text-align: left;">
                                <span>备注：</span>
                                <div style="width: 100%" v-for="(item, index) in bzList">
                                    <div style="margin:0 0 15px 30px">{{item.bz}}</div>
                                </div>
                            </el-col>
                        </el-row>
                    </el-main>
				</el-container>
            </el-card>
            <import-excel v-if="importVisible" ref="import" @refreshDataList="selectData()"></import-excel>
        </div>
    </div>
</template>

<script>
import importExcel from "./import-lrfx.vue"
export default {
    components:{
        importExcel
    },
    data(){
        return {
            total: 0,
            month: '',
            dataMonth: '',
            loading: false,
            exportLoding: false,
            importVisible: false,
            lrfxbList: [],
            zbr: '',
            bzList: [],
            maxAndMinMonth: Object,
            pickerOptions: {
                disabledDate:(time) => {
                    return (this.maxAndMinMonth.min&&(time.getTime() < this.maxAndMinMonth.min.getTime()))|| (this.maxAndMinMonth.max&&(time.getTime() > this.maxAndMinMonth.max.getTime()));
                }
            }
        }
    },
    created(){
        this.findMaxAndMinMonth()
    },
    methods: {
        searchData() {
            if (this.month) {
                this.loading = true
                this.$request({
                    method: 'get',
                    url: '/bjba/lrfx/getLrfxbInfo',
                    params: {time: this.month}
                }).then(res => {
                    this.loading = false
                    // console.log("返回的数据为：", res)
                    if (res.data.code == 200) {
                        this.dataMonth = this.month
                        if(res.data.data.total) this.total = res.data.data.total
                        else this.total = 0
                        this.lrfxbList = res.data.data.data
                        this.bzList = res.data.data.bzData
                        this.zbr = this.lrfxbList[0].zbr
                    } else {
                        this.$message({
                            message: "查询失败",
                            type: 'error',
                            duration: 3000
                        })
                    }
                }).catch(error => {
                    this.loading = false
                    this.$message({
                        message: "查询失败",
                        type: 'error',
                        duration: 3000
                    })
                })
            } else {
                this.$message({
                    message: "请选择日期",
                    type: 'error',
                    duration: 3000
                })
            }
           
        },
        selectData(){
            if(this.month) {
                this.searchData()
            }
            this.findMaxAndMinMonth()
        },
        findMaxAndMinMonth() {
			this.$request({
				url: '/bjba/lrfx/findMaxAndMinMonth',
				method: 'get'
			}).then(res => {
				// console.log(res.data.data)
				if (res.data.data && res.data.data.max && res.data.data.min) {
					this.$nextTick(() => {
                        this.maxAndMinMonth.max = this.$moment(res.data.data.max , "YYYY-MM").toDate()
					    this.maxAndMinMonth.min = this.$moment(res.data.data.min , "YYYY-MM").toDate()
                        this.pickerOptions = {
                            disabledDate:(time) => {
                                return (this.maxAndMinMonth.min&&(time.getTime() < this.maxAndMinMonth.min.getTime()))|| (this.maxAndMinMonth.max&&(time.getTime() > this.maxAndMinMonth.max.getTime()));
                            }
                        }
                    })
				}
			})
		},
        tableRowClassName({row, rowIndex}) {
            if (row.htmc) {
                if (row.htmc.indexOf("小计") > -1 || row.htmc.indexOf("总计") > -1) {
                    return 'success-row';
                }
            }
            
            return '';
        },
        /**
		 * 合并列实现方法 绑定
		 * @param row
		 * @param column
		 * @param rowIndex
		 * @param columnIndex
		 * @returns {*}
		 */
		objectSpanMethod({ row, column, rowIndex, columnIndex }) {
            if (columnIndex === 13 || columnIndex === 15 || columnIndex === 17) { 
               return [1,2]
            }
            if (columnIndex === 14 || columnIndex === 16 || columnIndex === 18) { 
                return [0,0];
            }
		},
        headerStyle({ row, column, rowIndex, columnIndex }) {
            if (rowIndex === 0) {
                row[7].rowSpan = 2;
                row[8].rowSpan = 2;
                row[9].rowSpan = 2;
                row[10].rowSpan = 2;
                row[13].rowSpan = 2;
                row[14].rowSpan = 2;
            }
            if (rowIndex === 1 && (columnIndex === 20 || columnIndex === 21 || columnIndex === 22 || columnIndex === 23 || columnIndex === 29 || columnIndex === 30)) {
                return 'display: none';
            }
            if (rowIndex === 2) {
                row[10].colSpan = 2;
                row[12].colSpan = 2;
                row[14].colSpan = 2;
            }
            if (rowIndex === 2 && (columnIndex === 11 || columnIndex === 13 || columnIndex === 15) ) { //隐藏第一个表头
                return 'display: none';
            }
            return {color:'black',borderColor:'black', textAlign: 'center'}
        },
        cellStyle({row, column, rowIndex, columnIndex}) {
			return 'height:35px!important; border-color:black!important; color:#000000!important; padding:0px!important; text-align:center'
		},
        importExcel(){
            this.importVisible = true
            this.$nextTick(() => {
				this.$refs.import.init()
			})
        },
        exportExcel(){
            // var viewUrl = `${this.$request.defaults.baseURL}/bjba/lrfx/test?access_token=${this.$store.getters.token}`
			// window.open(viewUrl)
            this.exportLoding = this.$loading({
                lock: true,
                text: '正在导出中，请耐心等待...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            var newMonth = ''
            if (this.month) {
                var year = this.month.substring(0,4)
                var month = this.month.substring(5,7)
                newMonth = year + '年' + month + '月'
            }
            this.$http({
                url: '/bjba/lrfx/exportExcel',
                method: 'post',
                data: {
                    lrfxbDataInfo: this.lrfxbList,
                    lrfxbBzDataInfo: this.bzList
                },
                params: {
                    month: newMonth,
                    zbr: this.zbr
                },
                responseType: 'blob'
            }).then(res => {
                // console.log("返回数据为：",res)
                this.exportLoding.close();
                if (res.data.size != 0) {
                    var fileName = newMonth + '份合同项目分析表';
                    this.downloadWordFile(res,fileName);
                } else {
                    this.$message
                    ({
                        message: "导出失败",
                        type: 'error',
                        duration: 1500
                    })
                }
            }).catch(error => {
                console.log("导出失败",error);
                this.exportLoding.close();
                this.$message
                    ({
                        message: "导出失败",
                        type: 'error',
                        duration: 1500
                    })
            })
        },
        downloadWordFile (fileData,fileName) {
            // console.log(fileName+'.xlsx');
            const blob = new Blob([fileData.data], {
                type: fileData.data.type
            })
            const url = URL.createObjectURL(blob)
            const a = document.createElement('A')
            
            a.download = fileName+'.xlsx'  //下载的文件名  自行设置
            a.href = url
            document.body.appendChild(a)
            a.click()
            document.body.removeChild(a)
        }
    }
}
</script>

<style scoped>
.el-table td, .el-table th.is-leaf,.el-table--border, .el-table--group{
    border-color: black;
}
.el-table--border::after, .el-table--group::after, .el-table::before{
    background-color: black;
}
</style>
<style>
.el-table .success-row {
    background: rgb(230, 253, 253);
    /* background-color: lightblue; */
}
</style>
